import './MyBids.css';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { WalletContext } from './WalletContext';
import WinningHistory from './WinningHistory';
import StarlineWinningHistory from './StarlineWinningHistory';

function MyBids({ onBack }) {
  const navigate = useNavigate();
  const { walletBalance } = useContext(WalletContext);
  const [showWinningHistory, setShowWinningHistory] = useState(false);
  const [showStarlineWinningHistory, setShowStarlineWinningHistory] = useState(false);

  const bidHistorySubtabs = {
    normal: {
      title: 'Normal Bid History',
      subtitle: 'You can view your market bid history'
    },
    starline: {
      title: 'Starline Bid History',
      subtitle: 'You can view your market starline bid history'
    }
  };

  const bidHistoryIcon = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="12" y="8" width="24" height="28" rx="2" stroke="#1e3a5f" strokeWidth="2" fill="white"/>
      <path d="M16 12H32M16 18H28M16 24H28M16 30H24" stroke="#1e3a5f" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="18" cy="36" r="8" fill="#e8eef5" stroke="#1e3a5f" strokeWidth="2"/>
      <path d="M18 32V40M14 36H22" stroke="#1e3a5f" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const winningHistoryIcon = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="12" y="8" width="24" height="28" rx="2" stroke="#1e3a5f" strokeWidth="2" fill="white"/>
      <path d="M16 12H32M16 18H28M16 24H28M16 30H24" stroke="#1e3a5f" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="18" cy="36" r="8" fill="#e8eef5" stroke="#1e3a5f" strokeWidth="2"/>
      <path d="M14 36L17 39L22 34" stroke="#1e3a5f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  if (showWinningHistory) {
    return <WinningHistory onBack={() => setShowWinningHistory(false)} />;
  }

  if (showStarlineWinningHistory) {
    return <StarlineWinningHistory onBack={() => setShowStarlineWinningHistory(false)} />;
  }

  return (
    <div className="my-bids-page">
      {/* Header */}
      <header className="my-bids-header">
        <button className="back-btn" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
        <h1>My Bids</h1>
        <button className="wallet-btn" onClick={() => navigate("/funds")}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="6" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/>
            <path d="M2 10H22" stroke="white" strokeWidth="2"/>
            <circle cx="18" cy="15" r="1.5" fill="white"/>
          </svg>
          <span className="wallet-balance">₹ {walletBalance}</span>
        </button>
      </header>

      {/* Bid History Cards */}
      <div className="bid-history-section">
        <div 
          className="bid-history-card"
          onClick={() => navigate('/normal-bid-history')}
        >
          <div className="bid-icon-wrapper">
            {bidHistoryIcon}
          </div>
          <div className="bid-content">
            <h3 className="bid-title">{bidHistorySubtabs['normal'].title}</h3>
            <p className="bid-subtitle">{bidHistorySubtabs['normal'].subtitle}</p>
          </div>
        </div>

        {/* Starline Bid History Card */}
        {/* <div 
          className="bid-history-card"
          onClick={() => navigate('/starline-bid-history')}
        >
          <div className="bid-icon-wrapper">
            {bidHistoryIcon}
          </div>
          <div className="bid-content">
            <h3 className="bid-title">{bidHistorySubtabs['starline'].title}</h3>
            <p className="bid-subtitle">{bidHistorySubtabs['starline'].subtitle}</p>
          </div>
        </div> */}
      </div>

      {/* Other History Cards */}
      <div className="bid-history-container">
        <div 
          className="bid-history-card"
          onClick={() => setShowWinningHistory(true)}
        >
          <div className="bid-icon-wrapper">
            {winningHistoryIcon}
          </div>
          <div className="bid-content">
            <h3 className="bid-title">Normal Winning History</h3>
            <p className="bid-subtitle">You can view your normal market winning history</p>
          </div>
        </div>

        {/* <div
          className="bid-history-card"
          onClick={() => setShowStarlineWinningHistory(true)}
        >
          <div className="bid-icon-wrapper">
            {winningHistoryIcon}
          </div>
          <div className="bid-content">
            <h3 className="bid-title">Starline Winning History</h3>
            <p className="bid-subtitle">You can view your starline market winning history</p>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default MyBids;
